import './App.css';
//import Home from './components/navbar/Home';
import Nav from './components/navbar/Nav';

function App() {
  return (
    <div className="App">
      <Nav/>
     
    </div>
  );
}

export default App;
